var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-2 mb-2",attrs:{"rounded":"","color":_vm.color},on:{"click":function($event){return _vm.$emit('click', _vm.value)}}},[_c('span',{staticClass:"text-large font-weight-bold"},[_vm._v(_vm._s(_vm.label || _vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }